import { render, staticRenderFns } from "./SelectCheckbox.vue?vue&type=template&id=06ba1d63"
import script from "./SelectCheckbox.vue?vue&type=script&lang=js"
export * from "./SelectCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SelectCheckbox.vue?vue&type=style&index=0&id=06ba1d63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports